export { default } from './id-card-upload';
